import { axiosClient } from '@nx-frontend/shared/api';
import { NoteDto } from '@nx-frontend/shared/types';
import { UpsertNoteDto } from '@nx-frontend/shared/types';

interface UpsertWorkspaceNoteParams {
  workspaceId: string;
  noteId: string;
  note: UpsertNoteDto;
}

export async function upsertWorkspaceNote({
  workspaceId,
  noteId,
  note,
}: UpsertWorkspaceNoteParams): Promise<NoteDto | null> {
  try {
    const response = await axiosClient.post<NoteDto>(`/v2/api/workspaces/${workspaceId}/notes/${noteId}/upsert`, {
      note,
    });
    return response.data;
  } catch (err) {
    console.error('Upsert note error: ', err);
  }
  return null;
}
